import { render, staticRenderFns } from "./receivingInformation.vue?vue&type=template&id=268b3eb7&"
import script from "./receivingInformation.vue?vue&type=script&lang=js&"
export * from "./receivingInformation.vue?vue&type=script&lang=js&"
import style0 from "./receivingInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports